module.exports = __webpack_public_path__ + "static/media/bg4.ca2a855c.jpg";